var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-top":"10px"}},[_c('v-form-render',{ref:"vFormRef",attrs:{"form-data":_vm.formConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }